import React from 'react';
import { Modal } from 'components/Modal';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { IDealerTicket } from 'thunks/RTKQuery/dealer';

interface IFMCustomerDetailModel {
  show: boolean;
  title: string;
  onClose: () => void;
  rowItem: IDealerTicket;
  setErrorString: (error: string) => void;
  updateDealerTicketsFMCustomer: (
    rowItem: IDealerTicket,
    fmCustomerId?: string,
    fmCustomerDescription?: string
  ) => void;
}

export const FMCustomerModelComponent = ({
  show,
  title,
  onClose,
  rowItem,
  setErrorString,
  updateDealerTicketsFMCustomer,
}: IFMCustomerDetailModel) => {
  const { t } = useTranslation();
  const [fmCustomer, setFmCustomer] = React.useState<string | null>(null);
  const [fmCustomerDescription, setFmCustomerDescription] = React.useState<
    string | null
  >(null);

  React.useEffect(() => {
    if (rowItem && rowItem.fmCustomerId) {
      setFmCustomer(rowItem.fmCustomerId);
    }
    if (rowItem && rowItem.fmCustomerDescription) {
      setFmCustomerDescription(rowItem.fmCustomerDescription);
    }
  }, [rowItem]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFmCustomer(e.target.value);
  };
  const handleChangeDescription = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFmCustomerDescription(e.target.value);
  };

  const handleSave = () => {
    if (rowItem?.ticketId) {
      setErrorString('');
      if (
        fmCustomer !== rowItem.fmCustomerId ||
        fmCustomerDescription !== rowItem.fmCustomerDescription
      ) {
        updateDealerTicketsFMCustomer(
          rowItem,
          fmCustomer ?? '',
          fmCustomerDescription ?? ''
        );
      }
      onClose();
    } else {
      setErrorString(t('dealerTickets.fmCustomerError'));
    }
  };

  return (
    <Modal
      title={title}
      show={show}
      onClose={onClose}
      closeOnOutSideClick={false}
      size="xl"
      className="customer-detail-modal"
      footer={
        <>
          <Row className="w-100 justify-content-end align-items-center">
            <Col xs="auto" className="d-flex align-items-center mt-10 mb-10">
              <Button
                className="customer-mode-footer-btn mr-2"
                variant="primary"
                size="sm"
                onClick={handleSave}
              >
                {t('dealerManagement.buttonSave')}
              </Button>
            </Col>
          </Row>
        </>
      }
    >
      <Row className="mt-20 mb-20">
        <Col md={10}>
          <Form.Group
            controlId="fmCustomerId"
            className="form-inline form-inline-dealer"
          >
            <Form.Label className="col-sm-4 mr-10 text-left ml-20">
              {t('customerManagement.fmCustomerId')}
            </Form.Label>
            <Form.Control
              className="col-sm-7 form-control-bordered margin-input"
              name="fmCustomerId"
              placeholder={t('customerManagement.fmCustomerId')}
              value={fmCustomer ?? ''}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group
            controlId="fmCustomerDescription"
            className="form-inline form-inline-dealer"
          >
            <Form.Label className="col-sm-4 mr-10 text-left ml-20">
              {t('customerManagement.fmCustomerDescription')}
            </Form.Label>
            <Form.Control
              className="col-sm-7 form-control-bordered margin-input jsonObject"
              name="fmCustomerDescription"
              as="textarea"
              placeholder={t('customerManagement.fmCustomerDescription')}
              value={fmCustomerDescription ?? ''}
              onChange={handleChangeDescription}
            />
          </Form.Group>
        </Col>
      </Row>
    </Modal>
  );
};

FMCustomerModelComponent.defaultProps = {};
